import { h, Component } from 'preact';
import { Header } from '@cube/blocks';
import { FinanceSpinner } from '../glyphs';
import { getCashFlow } from '@os/cloudquote';
import { CurrencyIndicator } from '../currency-indicator';
import style from './style';
import { Text } from 'preact-i18n';

const INTL_NS = 'stock-data-table';
const INTL_NS_CF = 'cashFlow';

import StockDataTable from './index';

export default class CashFlow extends Component {

	componentWillMount() {
		getCashFlow(this.props.symbol).then((data) => this.setState({ data }));
	}

	render({ timespan, ...props }, { data }) {
		let rows = data && data.rows;

		if (!rows || !rows.length) {
			return (
				<FinanceSpinner />
			);
		}

		return (
			<div>
				<Header class={style.dataHeader}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.cashFlow`} />}
					secondary={<Text id={`${INTL_NS}.${INTL_NS_CF}.numInMs`} />}
				>
					<CurrencyIndicator symbol={props.symbol} />
				</Header>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.periodEnding`} />}
					showDates
					cols={[
						{
							name: 'Net Income',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.netIncome`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.opActivities`} />}
					cols={[
						{
							name: 'Depreciation, Amortization, Depletion and Accretion',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.depAmort`} />
						},
						{
							name: 'Other Non-Cash Activities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.otherNonCash`} />
						},
						{
							name: 'Deferred Taxes',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.deferredTax`} />
						},
						{
							name: 'Change in Working Capital',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.changeWC`} />
						},
						{
							name: 'Total Cash from Operating Activities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.totalOperating`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.investActivities`} />}
					cols={[
						{
							name: 'Capital Expenditures',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.capEx`} />
						},
						{
							name: 'Other Investing Cash Flow',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.otherInvesting`} />
						},
						{
							name: 'Total Cash from Investing Activities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.totalInvesting`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.financingActivities`} />}
					cols={[
						{
							name: 'Dividends and Distributions',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.dividends`} />
						},
						{
							name: 'Purchase or Sale of Stock',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.buySellStock`} />
						},
						{
							name: 'Other Financing Cash Flow',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.otherFinancing`} />
						},
						{
							name: 'Purchase and Retirement of Debt',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.payDebt`} />
						},
						{
							name: 'Total Cash from Financing Activities',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.totalFinancing`} />,
							bold: true
						}
					]}
				/>
				<StockDataTable
					timespan={timespan}
					data={data}
					title={<Text id={`${INTL_NS}.${INTL_NS_CF}.exRateEffects`} />}
					cols={[
						{
							name: 'Exchange Rate Effects',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.exRate`} />
						},
						{
							name: 'Net Change in Cash',
							nameIntl: <Text id={`${INTL_NS}.${INTL_NS_CF}.changeCash`} />,
							bold: true
						}
					]}
				/>
			</div>
		);
	}
}
